import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchDoctorWithId_api } from "../../../api/api_calls/doctor_apiCalls";
import DoctorDetailsHeader from "../../../components/patient-side-components/doctor-profile-card/DoctorDetailsHeader";
import WeeklyCalendar from "../../../components/patient-side-components/doctor-view-calendar/WeeklyCalendar";
import { Badge } from "../../../components/ui/badge";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../../../components/ui/breadcrumb";
import { Button } from "../../../components/ui/button";
import { Separator } from "../../../components/ui/separator";
import { toast } from "../../../hooks/use-toast";

const PatientBookAppointment = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state } = location;

  const [doctor, setDoctor] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState();
  // const [selectedOption, setSelectedOption] = useState("audio");

  const fetchDoctorProfile = async () => {
    try {
      const res = await fetchDoctorWithId_api({
        doctorId: state?.doctorId || null,
      });
      console.log("RES => ", res);
      console.log("=== DOCTOR CONSULTATIONS STRUCTURE ===");
      console.log("Doctor consultations:", res.data?.consultations);
      if (res.data?.consultations?.length > 0) {
        console.log("First consultation structure:", res.data.consultations[0]);
        console.log(
          "First consultation keys:",
          Object.keys(res.data.consultations[0] || {}),
        );
      }
      console.log("=====================================");
      setDoctor(res.data);
    } catch (error) {
      toast({
        description: error.message,
        variant: "destructive",
      });
      console.log("ERROR IN fetchDoctorProfile  => ", error);
    }
  };

  useEffect(() => {
    fetchDoctorProfile();
  }, [state]);

  useEffect(() => {
    console.log("SELECTED DATE => ", selectedDate);
  }, [selectedDate]);

  const handleBookAppointment = () => {
    if (!selectedDate) {
      toast({ description: "Please select a slot", variant: "destructive" });
      return;
    }
    const slotDateTime = selectedDate?.date || selectedDate; // adjust if your selectedDate is a Date or object
    const now = new Date();
    if (new Date(slotDateTime) < now) {
      toast({
        description: "Appointment Cannot Be Booked in the Past",
        variant: "destructive",
      });
      return;
    }
    if (selectedIndex === undefined) {
      toast({ description: "Please select a service", variant: "destructive" });
      return;
    }

    const selectedService = doctor?.consultations?.[selectedIndex];

    if (!selectedService) {
      toast({
        description: "Invalid service selected",
        variant: "destructive",
      });
      return;
    }

    navigate("/patient/confirm-appointment", {
      state: {
        doctorId: state?.doctorId,
        selectedDate,
        selectedService, // Pass the complete service object
      },
    });
  };

  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div className="w-full py-4 sm:py-6 lg:py-8">
        <Breadcrumb>
          <BreadcrumbList className="flex flex-wrap items-center gap-1 sm:gap-2">
            <BreadcrumbItem>
              <BreadcrumbLink
                href="/"
                className="text-xs sm:text-sm md:text-base hover:text-primary"
              >
                Home
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-muted-foreground w-3 h-3 sm:w-4 sm:h-4" />
            <BreadcrumbItem>
              <BreadcrumbLink
                href="/"
                className="text-xs sm:text-sm md:text-base hover:text-primary"
              >
                Search Results
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-muted-foreground w-3 h-3 sm:w-4 sm:h-4" />
            <BreadcrumbItem>
              <BreadcrumbLink
                href="/"
                className="text-xs sm:text-sm md:text-base hover:text-primary"
              >
                Doctor Profile
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-muted-foreground w-3 h-3 sm:w-4 sm:h-4" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-xs sm:text-sm md:text-base font-medium">
                Book Appointment
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      <DoctorDetailsHeader
        doctor={doctor}
        showButton={true}
        buttonText="View Profile"
        onButtonClick={() =>
          navigate("/patient/doctor-profile", {
            state: { doctorId: state?.doctorId },
          })
        }
      />

      <Separator className="my-8" />
      <WeeklyCalendar
        doctorId={state?.doctorId}
        minimalMode={true}
        setSelectedDate={setSelectedDate}
        selectedDate={selectedDate}
      />

      <div className="w-full px-4 sm:px-6 lg:px-8 flex flex-col gap-4">
        <div className="py-4">
          <h3 className="font-bold text-lg sm:text-xl lg:text-2xl">
            Services & Pricing{" "}
            <span className="font-normal text-sm sm:text-base lg:text-lg">
              (per session)
            </span>
          </h3>
        </div>
        <div className="flex flex-wrap gap-2 sm:gap-4">
          {doctor?.consultations?.map((consultation, idx) => {
            const isSelected = idx === selectedIndex;
            return (
              <Badge
                key={idx}
                onClick={() => setSelectedIndex(idx)}
                variant="outline"
                className={`cursor-pointer text-sm sm:text-base lg:text-lg font-semibold py-1 px-4 rounded-lg flex gap-2 items-center transition-colors ${
                  isSelected ? "bg-[#0052FD] text-white" : "bg-[#0052FD14]"
                }`}
              >
                <span>{consultation?.serviceName}</span>
                <span>${consultation?.price}</span>
              </Badge>
            );
          })}
        </div>
      </div>

      <Separator className="my-8" />

      <div className="w-full items-center justify-center flex my-6">
        <Button variant={"primary"} onClick={handleBookAppointment}>
          Book Appointment
        </Button>
      </div>
    </div>
  );
};

export default PatientBookAppointment;
